import { Context, useContext } from 'react';

// https://www.telerik.com/blogs/how-to-use-context-api-with-hooks-efficiently-while-avoiding-performance-bottlenecks

export function createUseContext<T>(name: string, context: Context<T>) {
  return () => {
    const ctx = useContext(context);
    if (ctx === undefined) {
      throw new Error(`Provider missing for ${name}`);
    }
    return ctx as NonNullable<T>;
  };
}
